import { styled } from 'styled-components';

import { Container } from 'react-bootstrap';

import { Loader, Typography } from '@vivaahealth/design-system';

export const NKCH_ORGANIZATION_IDENTIFIER =
  'dd9dbde1-b8eb-4d3b-8a2e-e9e57fc78d9c';
export const KRIEGER_ORGANIZATION_IDENTIFIER =
  '45156d5d-9abe-43f4-b3e4-68cf6d11c799';
export const MIT_ORGANIZATION_IDENTIFIER =
  '3631257e-625c-4703-a5c4-c6a15c6041cb';
export const LOCAL_ORGANIZATION_IDENTIFIER = '';

export const ORGANIZATION_ID_TO_REPUTATION_TENANT_CODE: {
  [key: string]: string;
} = {
  [NKCH_ORGANIZATION_IDENTIFIER]: '11021e7c077',
  [KRIEGER_ORGANIZATION_IDENTIFIER]: '11021e7c077',
  [LOCAL_ORGANIZATION_IDENTIFIER]: '11021e7c077',
};

export const ORGANIZATION_ID_TO_ORIGIN: {
  [key: string]: string[];
} = {
  [LOCAL_ORGANIZATION_IDENTIFIER]: ['<customer app origin>'],
  [KRIEGER_ORGANIZATION_IDENTIFIER]: ['https://www.nkch.org'],
  [NKCH_ORGANIZATION_IDENTIFIER]: [
    'https://www.nkch.org',
    'https://stage-nkch-ih.cphostaccess.com',
  ],
  [MIT_ORGANIZATION_IDENTIFIER]: ['https://medical.mit.edu'],
};

export const ORGANIZATION_ID_TO_PROFILE_PATH: {
  [key: string]: string;
} = {
  [LOCAL_ORGANIZATION_IDENTIFIER]: '',
  [KRIEGER_ORGANIZATION_IDENTIFIER]:
    'https://www.nkch.org/find-a-provider/profile',
  [NKCH_ORGANIZATION_IDENTIFIER]:
    'https://www.nkch.org/find-a-provider/profile',
};

export enum CategoryType {
  Insurance = 'INSURANCE',
  Specialty = 'SPECIALTY',
}

export interface SearchItem {
  categoryType: CategoryType;
  name: string;
}

// Workaround for https://app.asana.com/0/1202570258641761/1204836327247889
export const StyledTypography = styled(Typography).attrs<{ color: string }>(
  (props) => ({
    color: props.color,
  }),
)`
  color: ${(props) => props.color};
`;

export const CenteredLoader = styled(Loader)`
  margin: auto;
`;

export const EmbeddedFluidContainer = styled(Container)`
  padding: 0;
  @media (min-width: 1200px) {
    max-width: 1164px;
  }
`;

export const StyledHeaderSmall = styled(Typography)`
  margin-bottom: 10px;
`;

export const StyledBorder = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
  border-bottom: 1px var(--color-shade-50) solid;
`;
